import { DefaultValue, atom, selector } from "recoil"

export type PrivateRoomTabTarget = "NEW_TAB" | "CURRENT_TAB" | "UN_DEF"

export type PrivateRoomData = {
  roomName: string
  userName: string
  uniqueId: string
  createUserKey?: string
}

export const privateRoomTabTypeAtom = atom<PrivateRoomTabTarget>({
  key: "privateRoomTabTypeAtom",
  default: "UN_DEF" // because audience default tab is current
})

export const privateRoomDataAtom = atom<PrivateRoomData | null | undefined>({
  key: "privateRoomDataAtom",
  default: null
})

export const startPrivateRoomAtom = atom<boolean>({
  key: "startPrivateRoomAtom",
  default: false
})

export const isPrivateRoomAtom = atom<boolean>({
  key: "isPrivateRoomAtom",
  default: false
})

export const privateRoomSelector = selector<{
  action: "OPEN" | "RESET"
  data?: any
}>({
  key: "privateRoomSelector",
  get: () => ({ action: "RESET", data: null }),
  set: ({ set, reset }, value) => {
    if (value instanceof DefaultValue) return

    const { action, data } = value

    if (action === "OPEN") {
      set(privateRoomDataAtom, data)
      set(startPrivateRoomAtom, true)
    }

    if (action === "RESET") {
      reset(startPrivateRoomAtom)
      reset(privateRoomTabTypeAtom)
      reset(privateRoomDataAtom)
    }
  }
})

export const setPrivateRoomSelector = selector<{
  isPrivateRoom: boolean
  privateRoomData?: PrivateRoomData | null
}>({
  key: "setPrivateRoomSelector",
  get: ({ get }) => ({
    isPrivateRoom: get(isPrivateRoomAtom),
    privateRoomData: get(privateRoomDataAtom)
  }),
  set: ({ set }, value) => {
    if (value instanceof DefaultValue) return

    const { isPrivateRoom, privateRoomData } = value
    set(privateRoomDataAtom, privateRoomData)
    set(isPrivateRoomAtom, isPrivateRoom)
  }
})

export const privateRoomCallbackSelector = selector({
  key: "privateRoomCallbackSelector",
  get: ({ getCallback, get }) => {
    const checkIsPrivateRoom = getCallback(({ snapshot }) => async () => {
      return await snapshot.getPromise(isPrivateRoomAtom)
    })
    return { checkIsPrivateRoom }
  }
})
